import { useRecoilState, useRecoilValue } from 'recoil';
import { webcamAtom, screenShareAtom, remoteUsersAtom } from '../../State';
import { useLocalSessionId, useDaily } from '@daily-co/daily-react';
import './Live2d.css';
import * as PIXI from 'pixi.js';

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Live2dAvatar from './Live2dAvatar';
import DetectRemoteUsers from '../Call/DetectRemoteUsers';
import RecordLocal from './RecordLocal';
import MuteLocal from './MuteLocal';
import Screenshare from './ScreenShare';
import Background from './Background';
import InfoBox from './InfoBox';
import { calulateSize } from './Live2dWrapCalcSize';
import { isMobile } from 'react-device-detect';

//グローバルに追加しておかないと動かない
window.PIXI = PIXI;

export default function Live2dWrap({
  isHairCheck,
  isFaceScreen,
  isLiveViewer = false,
  isLive,
  isRecord = false,
}) {
  //Daily系
  const localSessionId = 'myID'; //useLocalSessionId();

  //Recoil系
  const remoteUsersState = useRecoilValue(remoteUsersAtom);
  const screenShareState = useRecoilValue(screenShareAtom);

  //その他
  const [canvasWidth, setCanvasWidth] = useState(1000);
  const [canvasHeight, setCanvasHeight] = useState(700);
  const pixiRef = useRef(null); //PIXIオブジェクト
  const wrapRef = useRef(null); //キャンバスを囲むdiv
  const canvasRef = useRef(null); //キャンバス
  const wrapWidthRef = useRef(800); //アバターを囲むエリアの幅
  const wrapHeightRef = useRef(700); //アバターを囲むエリアの高さ
  const eachWidthRef = useRef(200); //各アバターの最大サイズ
  const workerRef = useRef(null);

  var remoteUserCount = remoteUsersState != null ? remoteUsersState.length : 0;
  let avatarCount = isLiveViewer ? remoteUserCount : 1 + remoteUserCount;

  //初期化の時
  useEffect(() => {
    //Live2Dの読み込み
    initLive2dArea();
  }, []);

  //リモートユーザー情報が変わるたびに呼ばれる
  useEffect(() => {
    if (pixiRef.current == null) return;
    //レイアウト計算
    setSize();
  }, [remoteUsersState, canvasHeight, canvasWidth, screenShareState]);

  //Live2Dの読み込み
  async function initLive2dArea() {
    if (pixiRef.current != null) return;

    //PIXIの初期化
    pixiRef.current = new PIXI.Application({
      view: canvasRef.current,
      autoStart: true,
      //   backgroundAlpha: 0,
      backgroundColor: 0x000000,
      resizeTo: wrapRef.current,
      resolution: window.devicePixelRatio || 1, //Retinaディスプレイ対策
      autoDensity: true,
    });

    //ソートできるように
    pixiRef.current.stage.sortableChildren = true;

    //FPS設定
    pixiRef.current.ticker.minFPS = 10;
    pixiRef.current.ticker.maxFPS = 30;
    //console.log(pixiRef.current.ticker.FPS);
    // var dd = new PIXI.Application();
    // dd.stage.sortableChildren = true;

    //レイアウト計算
    setSize();

    //ブラウザバックグランド処理
    setBackgroundProcess();

    // ctx.current = pixiRef.current.renderer.context;

    //console.log('レンダーCTX');
    //console.log(pixiRef.current.renderer.context);

    // PIXI.CanvasResource.
    // const clonedCanvas = PIXI.extract.CanvasExtract.getCanvas(stage, renderer.resolution);

    //    let dd = new PIXI.Application();

    //renderer.render(stage);

    pixiRef.current.renderer.on('resize', (width, height) => {
      setSize(width, height);
      //レイアウト計算
      // if (isMobile) {
      //   setTimeout(() => {
      //     var w = window.innerWidth;
      //     var h = window.innerHeight;
      //     setSize(w, h);
      //   }, 1300);
      // } else {
      //   setSize(width, height);
      // }
    });
  }

  //バックグランド処理のリスナー
  function setBackgroundProcess() {
    // ページの表示状態が変わったときに実行
    document.addEventListener('visibilitychange', function () {
      let status = document.visibilityState;

      //ブラウザがバックグランドへ行った
      if (status == 'hidden') {
        workerRef.current = new Worker('js/worker.js');

        //Workerにメッセージを送信(Worker処理開始)
        workerRef.current.postMessage('start');

        workerRef.current.addEventListener(
          'message',
          function (e) {
            let diff = e.data;
            if (pixiRef.current != null) {
              pixiRef.current.renderer.render(pixiRef.current.stage);
            }
          },
          false,
        );
      }
      //ブラウザが再度アクティブになった
      else {
        if (workerRef.current != null) {
          workerRef.current.terminate();
          workerRef.current = null;
        }
      }
    });
  }

  //各Live2Dエリアのサイズの設定
  function setSize(width, height) {
    //計算後のキャンバスサイズの取得
    let [newWidth, newHeight] = calulateSize(
      width,
      height,
      wrapWidthRef,
      canvasRef,
      eachWidthRef,
      avatarCount,
    );

    //alert(newWidth);
    setCanvasWidth(newWidth);
    setCanvasHeight(newHeight);
  }

  //CSSの変更
  var wrapID = 'live2dCanvasWrap';
  //モバイルの場合
  if (isMobile) {
    wrapID = 'live2dCanvasMobile';
  }
  //スクリーンシェア中の場合
  else if (screenShareState != null) {
    wrapID = 'live2dCanvasWrapScreen';
  }

  return (
    <>
      {/* スクリーンシェア */}
      <Screenshare
        canvasRef={canvasRef}
        pixiRef={pixiRef}
        wrapRef={wrapRef}
        canvasWidth={canvasWidth}
        canvasHeight={canvasHeight}
      />

      {/* 背景 */}
      <Background
        pixiRef={pixiRef}
        canvasRef={canvasRef}
        canvasWidth={canvasWidth}
        canvasHeight={canvasHeight}
      />

      {/* 録画機能 */}
      <RecordLocal canvasRef={canvasRef} />

      {/* ミュート機能 */}
      <MuteLocal />

      {/* リモートユーザーの変更検知 */}
      <DetectRemoteUsers isLiveViewer={isLiveViewer} />

      {/* Live2D表示 */}
      <div id={wrapID} ref={wrapRef}>
        {pixiRef.current != null && (
          <>
            {/* 自分 */}

            {isLiveViewer == false && (
              <Live2dAvatar
                key={localSessionId}
                isMe={true}
                id={localSessionId}
                app={pixiRef}
                canvasWidth={canvasWidth}
                canvasHeight={canvasHeight}
                canvasRef={canvasRef}
                wrapWidthRef={wrapWidthRef}
                eachWidthRef={eachWidthRef}
                avatarCount={avatarCount}
                index={0}
                isHairCheck={isHairCheck}
                isFaceScreen={isFaceScreen}
                isRecord={isRecord}
              />
            )}

            {/*リモートアバターの表示 */}
            {remoteUsersState != null && remoteUsersState.length > 0 ? (
              <>
                {remoteUsersState.map((id, index) => (
                  <Live2dAvatar
                    key={id}
                    isMe={false}
                    id={id}
                    app={pixiRef}
                    canvasWidth={canvasWidth}
                    canvasHeight={canvasHeight}
                    canvasRef={canvasRef}
                    wrapWidthRef={wrapWidthRef}
                    eachWidthRef={eachWidthRef}
                    avatarCount={avatarCount}
                    index={isLiveViewer ? index : index + 1}
                    isHairCheck={isHairCheck}
                  />
                ))}
              </>
            ) : (
              <>
                {/*シェアしての画面 */}
                {isHairCheck == false && isRecord == false && isLiveViewer == false && (
                  <InfoBox isLive={isLive} />
                )}
              </>
            )}
          </>
        )}
        {/*キャンバス */}
        <canvas ref={canvasRef}></canvas>
      </div>
    </>
  );
}
